import { render, staticRenderFns } from "./MulticartWizard.vue?vue&type=template&id=3ad284fc"
import script from "./MulticartWizard.vue?vue&type=script&lang=js"
export * from "./MulticartWizard.vue?vue&type=script&lang=js"
import style0 from "./MulticartWizard.vue?vue&type=style&index=0&id=3ad284fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports